import React from 'react'
import Instruments from '../Instruments/Instruments'
import styles from './styles.module.css'
import Table from '../../ui/Table/Table'
import { Button } from '../../ui'

const EDSComponent = ({ selfHead, change }) => {
	return (
		<div className={styles.wrapper}>
			<Instruments selfHead={selfHead} change={change} leftHead='Справка к ЭЦП' rightHead='Подписанные справки' />
			<div>
				<Table
					head={
						<tr>
							<th>№</th>
							<th>ФИО</th>
							<th>Исполнитель</th>
							<th>Группа</th>
							<th>Документ</th>
							<th>Дата подписи</th>
							<th>Название файла</th>
							<th>Действие</th>
						</tr>
					}
					body={
						<tr>
							<td>1</td>
							<td>Абдрасулов Адилет Абдрасулович</td>
							<td>Тащташов</td>
							<td>Группа</td>
							<td>Документ</td>
							<td>Дата подписи</td>
							<td>faafds</td>
							<td>
								<Button value='Подписать' />
							</td>
						</tr>
					}
				/>
			</div>
		</div>
	)
}

export default EDSComponent
